export const FETCH_CUISINE_TYPE = {
  START: 'START_FETCH_CUISINE_TYPE',
  COMPLETE: 'COMPLETE_FETCH_CUISINE_TYPE',
  FAIL: 'FAIL_FETCH_CUISINE_TYPE',
  CLEANUP: 'CLEANUP_FETCH_CUISINE_TYPE',
}

export const UPDATE_CUISINE_TYPE_SIMPLE_DETAILS = {
  START: 'START_UPDATE_CUISINE_TYPE_SIMPLE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_CUISINE_TYPE_SIMPLE_DETAILS',
  FAIL: 'FAIL_UPDATE_CUISINE_TYPE_SIMPLE_DETAILS',
}

export const UPDATE_CUISINE_TYPE_IMAGE_DETAILS = {
  START: 'START_UPDATE_CUISINE_TYPE_IMAGE_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_CUISINE_TYPE_IMAGE_DETAILS',
  FAIL: 'FAIL_UPDATE_CUISINE_TYPE_IMAGE_DETAILS',
}
